import { Link } from 'react-router-dom'
import { LandingButton, Reveal } from '../primitives'

const PLANS = [
  {
    name: 'Free',
    price: '$0',
    cadence: 'forever',
    lines: ['Unlimited trips and vehicles', '8 crew per trip', 'Meals, gear and itinerary', 'GPX import', '1 GB of photos'],
  },
  {
    name: 'Pro',
    price: '$4.99',
    cadence: 'a month, or $39.99 a year',
    lines: [
      'Unlimited crew',
      'Per-link sharing permissions',
      'Campsite finder and Ranger',
      'Campspotter weather and 3D route tours',
      '5 GB of photos',
    ],
  },
]

export function PricingSection() {
  return (
    <section id="pricing" className="l-anchor pt-[var(--l-section)]">
      <div className="l-frame grid gap-10 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-5">
          <Reveal as="h2" className="l-head">
            Pricing
          </Reveal>
          <Reveal delay={60} className="mt-4">
            <Link to="/pricing" className="l-link l-link--always l-small l-soft">
              Compare every feature
            </Link>
          </Reveal>
        </div>

        <div className="grid gap-12 sm:grid-cols-2 lg:col-span-6 lg:col-start-7 lg:gap-8">
          {PLANS.map((plan, index) => (
            <Reveal key={plan.name} delay={60 + index * 60} className="flex flex-col">
              <div className="flex items-baseline justify-between gap-4 tabular-nums">
                <p className="font-medium">{plan.name}</p>
                <p className="font-medium">{plan.price}</p>
              </div>
              <p className="l-soft l-small mt-0.5 text-right">{plan.cadence}</p>
              <ul className="l-soft mb-6 mt-5 space-y-1">
                {plan.lines.map((line) => (
                  <li key={line}>{line}</li>
                ))}
              </ul>
              <div className="mt-auto">
                {plan.name === 'Pro' ? (
                  <LandingButton to="/signup">Start free trial</LandingButton>
                ) : (
                  <Link to="/signup" className="l-link l-link--always l-small inline-flex min-h-[44px] items-center font-medium">
                    Get started
                  </Link>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
